module.exports = __webpack_public_path__ + "static/media/NotoSansKR-Thin-Alphabetic.c345becc.woff2";